module.exports = __webpack_public_path__ + "c57d577af575e899fd105ae26cf63072.png";